<script lang="ts" setup>
defineProps<{
  title?: string;
  description?: string;
}>();
</script>

<template>
  <div class="text-center mb-24 space-y-6 container-xl">
    <h2 class="heading-1">
      {{ title }}
    </h2>
    <p v-if="description" class="paragraph-lg">
      {{ description }}
    </p>
  </div>
</template>
